import { Directive } from '@angular/core';
import { DropTargetDirective } from '@features/drag-and-drop/drop-target.directive';

@Directive({
  selector: '[lpDropTarget]',
})
export class LpDropTargetDirective extends DropTargetDirective {}
